import React from "react";
import {
  checkForAppUpdate,
  useAppVersionState,
} from "@/lib/appVersionStore";

export function useStaleAppVersion(checkOnMount = false) {
  const appVersionState = useAppVersionState();
  const [isChecking, setIsChecking] = React.useState(
    checkOnMount && !appVersionState.updateAvailable,
  );

  React.useEffect(() => {
    if (!checkOnMount || appVersionState.updateAvailable || !import.meta.env.PROD) {
      setIsChecking(false);
      return;
    }

    let isCancelled = false;
    setIsChecking(true);

    void checkForAppUpdate().finally(() => {
      if (!isCancelled) {
        setIsChecking(false);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [appVersionState.updateAvailable, checkOnMount]);

  return {
    ...appVersionState,
    isChecking,
  };
}
